export const IDENTIFICATION_METHOD_TOOLTIPS = {
  BINARY_FINGERPRINT: {
    TITLE: 'Binary Fingerprint',
    CONTENT: 'Identifies components using binary-level analysis of compiled code structures.'
  },
  KERNEL_MODULE: {
    TITLE: 'Kernel Module',
    CONTENT: 'Detects Linux kernel modules (.ko files) through file analysis.'
  },
  CURATED_HASH: {
    TITLE: 'Curated Hash',
    CONTENT: 'Matches file hashes against our maintained database of known component files across distributions.'
  },
  LEGACY_HASH: {
    TITLE: 'Legacy Hash',
    CONTENT: 'Matches file hashes against a historical reference list of known files.'
  },
  LIBRARY_VERSION: {
    TITLE: 'Library + Version',
    CONTENT: 'Identifies shared libraries using both filename and version information extracted from the file.'
  },
  LIBRARY_NAME: {
    TITLE: 'Library Name',
    CONTENT: 'Identifies shared libraries using only the filename without version matching.'
  },
  PACKAGE_MANIFEST: {
    TITLE: 'Package Manifest',
    CONTENT: 'Extracts component information directly from package manager files (npm, pip, cargo, etc.).'
  },
  PE_METADATA: {
    TITLE: 'PE Metadata',
    CONTENT: 'Identifies Windows components using metadata embedded in Portable Executable files.'
  },
  SIGNATURE_DETECTION: {
    TITLE: 'Signature Detection',
    CONTENT: 'Identifies components using pattern matching against known software signatures.'
  },
  SYMBOL_INDEX: {
    TITLE: 'Symbol Index',
    CONTENT: 'Matches components based on exported function and symbol tables in binaries.'
  },
  USER_MODIFIED: {
    TITLE: 'User Modified',
    CONTENT: 'Identifies components that were manually remediated by the user.'
  },
  ROOT: {
    TITLE: 'Root',
    CONTENT: 'Identifies the root component of the asset.'
  }
};

export const {
  BINARY_FINGERPRINT,
  KERNEL_MODULE,
  CURATED_HASH,
  LEGACY_HASH,
  LIBRARY_VERSION,
  LIBRARY_NAME,
  PACKAGE_MANIFEST,
  PE_METADATA,
  SIGNATURE_DETECTION,
  SYMBOL_INDEX,
  USER_MODIFIED,
  ROOT
} = IDENTIFICATION_METHOD_TOOLTIPS;
